import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "changeDocumentStatusModal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "changeDocumentStatusModalLabel"
  }, "Are you sure?"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, "Do you want to " + _toDisplayString(_ctx.setup.action === 'APPROVE' ? 'approve' : 'decline') + " this document?", 1),
          (_ctx.setup.action === 'DECLINE')
            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                key: 0,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
                class: "form-control",
                placeholder: "Comment (Optional)"
              }, null, 512)), [
                [_vModelText, _ctx.comment]
              ])
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (_ctx.setup.action === 'APPROVE')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeDocumentStatus && _ctx.changeDocumentStatus(...args))),
                type: "button",
                class: "btn btn-success",
                "data-bs-dismiss": "modal"
              }, " Approve "))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeDocumentStatus && _ctx.changeDocumentStatus(...args))),
                type: "button",
                class: "btn btn-danger",
                "data-bs-dismiss": "modal"
              }, " Decline "))
        ])
      ])
    ])
  ]))
}